import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MatDialogState, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { ProductAddedDialogComponent } from 'src/app/modules/products/components/product-added-dialog/product-added-dialog.component';
import { Product } from 'src/app/openapi/api';
import { FavoritesService } from 'src/app/services/favorites/favorites.service';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-popup-menu-favorites',
  templateUrl: './popup-menu-favorites.component.html',
  styleUrls: ['./popup-menu-favorites.component.scss']
})
export class PopupMenuFavoritesComponent extends BaseComponent implements OnInit {
  @Output() isFocused = new EventEmitter<boolean>();

  favorites: Product[];
  loading: boolean;
  error: boolean;

  constructor(
    public override responsive: ResponsiveService,
    public override transloco: TranslocoService,
    private dialogRef: MatDialogRef<ProductAddedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private router: Router,
    private favoritesService: FavoritesService,
  ) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
    this.getFavorites();
  }

  mouseEnter() {
    if (this.dialogRef.getState() === MatDialogState.OPEN) {
      this.isFocused.emit(true);
    }
  }

  mouseLeave() {
    this.isFocused.emit(false);
  }

  private async getFavorites(): Promise<void> {
    this.loading = true;

    try {
      this.favorites = await this.favoritesService.getFavorites();
    } catch (error) {
      error = true;
    }

    this.loading = false;
  }

  productSelected(product: Product) {
    this.router.navigate(['/products/product-detail/', product.id]);
    this.dialogRef.close();
    this.isFocused.emit(false);
  }

  onClickButtonEmpty() {
    this.router.navigate(['/products']);
    this.dialogRef.close();
    this.isFocused.emit(false);
  }

  onClickButton() {
    this.router.navigate(['/products/products-favorites']);
    this.dialogRef.close();
    this.isFocused.emit(false);
  }
}
